import { React } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import NavigasiBar from "./NavigasiBar";

export const AnimalPage = ({animalList, searchWords, setSearchWords}) => {
    return(
        <div className="d-flex container flex-column justify-content-start align-items-center">
            <NavigasiBar/>
            <h3 className="judul zoomInLeft">Daftar Hewan Gemoy Di Dunia </h3>
            <input className="form-control mb-3" 
            value={searchWords}
            onChange={(ev)=>setSearchWords(ev.currentTarget.value)}/>
            
            <div className="wrapper">
                {
                    animalList.map((animal)=>{
                        return(
                            <Link className="link" to={`/animal/${animal.id}`} key={animal.id}>
                                <div id="MyDiv" className="rubberBand gambar-wrapper d-inline-flex justify-content-start align-items-center">
                                    <img className="gambar" src={animal.imageLink} alt={animal.name} style={{ width: '100px', height:'100px' }} />
                                    <div className="d-flex flex-column justify-content-start align-items-start">
                                        <p className="fw-bold">Nama: <span>{animal.name}</span></p>
                                        <p className="fw-bold">Habitat : <span>{animal.habitat}</span></p>
                                        <p className="fw-bold">Nama Latin : <span>{animal.latinName}</span></p>
                                    </div>
                                </div>
                            </Link>
                            
                        )
                    })
                }
            </div>
        </div>
    );
}

// export default AnimalPage;